import PageHeader from "@/app/shared/page-header";
import UsersTable from "@/app/shared/roles-permissions/users-table";
import { fetchUsers } from "@/server/api-services";
import { User } from "@/types";
import { useState, useEffect } from "react";

const pageHeader = {
    title: "User Management",
    breadcrumb: [
        {
            href: "/",
            name: "Home",
        },
        {
            name: "User Management",
        },
    ],
};

export default function BlankPage() {
    const [users, setUsers] = useState([] as User[]);

    useEffect(() => {
        getUsers();
    }, []);

    async function getUsers() {
        try {
            const response = await fetchUsers();
            const data = response.data as User[];
            setUsers(data);
        } catch (error) {
            console.error("Failed to fetch users:", error);
        }
    }

    const refreshUsers = () => {
        getUsers();
    };

    return (
        <>
            <PageHeader
                title={pageHeader.title}
                breadcrumb={pageHeader.breadcrumb}
            />
            <UsersTable usersData={users} refreshUsers={refreshUsers} />
        </>
    );
}
